import { render, staticRenderFns } from "./eventDataList.vue?vue&type=template&id=d0f68ae0&scoped=true"
import script from "./eventDataList.vue?vue&type=script&lang=js"
export * from "./eventDataList.vue?vue&type=script&lang=js"
import style0 from "./eventDataList.vue?vue&type=style&index=0&id=d0f68ae0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0f68ae0",
  null
  
)

export default component.exports